<template>
  <b-form-group
    :label="label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <file-input-field
      v-bind="$props"
      ref="uploader"
      @input="filesChanged(arguments[0])"
    />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import FileFieldMixin from 'vue-forms/mixins/FileFieldMixin';

export default {
  mixins: [ FormFieldMixin, FileFieldMixin ],

  methods: {
    reset() {
      this.$refs.uploader.reset();
    }
  }
};
</script>
